<template>
  <div class="windowControlsLeft">
    <!--<b-button :disabled="true" size="sm" variant="dark" type="dark" class="headerSmallButton headerDragHandle"><icon name="arrows-alt" scale=".7"></icon></b-button>-->
    <label>{{cmpTitle}}</label>
  </div>
</template>

<script>
  export default {
    name: 'WindowHeaderLeft',
    props: {
      cmpTitle: {
        default: ""
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/WindowHeaderLeft.vue